"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'email.payment.success.subject': 'Pago exitoso - Suscripción confirmada',
    'email.payment.success.title': '¡Pago procesado exitosamente!',
    'email.payment.success.text': 'Gracias por su pago. Su suscripción ha sido confirmada y ahora está activa.',
    'email.payment.success.confirmation': 'Recibirá un recibo de este pago en breve.',
    'email.payment.success.footer': 'Si tiene alguna pregunta, por favor contacte a nuestro equipo de soporte.',
    'email.payment.failed.subject': 'Pago fallido - Acción requerida',
    'email.payment.failed.title': 'Error en el procesamiento del pago',
    'email.payment.failed.text': 'No pudimos procesar su pago para su suscripción. Por favor actualice su método de pago para continuar usando nuestros servicios.',
    'email.payment.failed.retry_text': 'Para evitar la interrupción del servicio, por favor reintente su pago lo antes posible.',
    'email.payment.failed.retry_button': 'Reintentar pago',
    'email.payment.failed.support_button': 'Contactar soporte',
    'email.payment.failed.footer': 'Si continúa experimentando problemas, por favor contacte a nuestro equipo de soporte para obtener ayuda.',
    'email.payment.plan': 'Plan de suscripción',
    'email.payment.amount': 'Cantidad',
    'email.payment.next_billing': 'Próxima fecha de facturación',
    'email.payment.failure_reason': 'Razón del fallo',
    'email.payment.dashboard_button': 'Ver panel',
    'email.payment.download_invoice': 'Descargar factura',
};
